import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', height: '100vh', background: 'rgb(247, 244, 244)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Container maxWidth="sm">
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 0 }}>
          <Paper elevation={3} sx={{ padding: 4, width: '100%', textAlign: 'center' }}>
            <Typography variant="h5" mb={2}>
              Registration successful
            </Typography>
            <Typography variant="body1" mb={3}>
              Please check your email to activate your account
            </Typography>
            <Button variant="contained" onClick={() => navigate('/login')}>
              Sign in
            </Button>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default RegistrationSuccess; 